export enum PROJECT_TYPE_OF_WORK {
  BILLABLE = 'BILLABLE',
  NON_BILLABLE = 'NON_BILLABLE',
}
